// Custom js for sub menu open
var searchOpen = document.querySelector('.primary-menu .menu-button.search .text')
var search = document.querySelector('.primary-menu .menu-button.search')
var bodyTag = document.querySelector('#site-header')


if(searchOpen){
  searchOpen.addEventListener('click', function() {
        search.classList.toggle('active');
        bodyTag.classList.toggle('search-open');
  });
}

// Custom js for sub menu open
var searchOpenMobile = document.querySelector('.mobile-menu .menu-button.search .text')
var searchMobile = document.querySelector('.mobile-menu .menu-button.search')

if(searchOpenMobile){
  searchOpenMobile.addEventListener('click', function() {
        searchMobile.classList.toggle('active');
  });
}